import React from "react";
import "./comingsoon.css";

export default function ComingSoonModal({ isOpen, onClose, title, message }) {
    
  if (!isOpen) return null;

  return (
    <div className="csm__overlay" onClick={onClose}>
      <div className="csm__box" onClick={e => e.stopPropagation()}>
        <button className="csm__close" onClick={onClose} aria-label="Close">✕</button>
        <div className="csm__eyebrow">The Axis</div>
        <h2 className="csm__title">{title}</h2>
        <p className="csm__body">{message}</p>
        <div className="csm__actions">
          <button className="btn btn--primary" onClick={onClose}>Got It</button>
          <a className="btn btn--ghost" href="/contact">Contact Us</a>
        </div>
      </div>
    </div>
  );
}